/**
 * Task E — Reusable TCP logo mark.
 *
 * Single import surface so every auth page, empty state, onboarding step,
 * and 404 renders the official logo in a consistent, cinematic way.
 *
 * Visual rule: white card behind the mark for contrast against #0A0F1A
 * (the logo lives best on light), with controllable size.
 */
import React from "react";
import logoMark from "../assets/logo-tcp-mark.png";

const SIZES = {
    sm: { box: "h-9 px-2", img: "h-5" },
    md: { box: "h-11 px-2.5", img: "h-7" },
    lg: { box: "h-14 px-3", img: "h-9" },
    xl: { box: "h-20 px-4", img: "h-12" },
};

export default function LogoMark({
    size = "md",
    className = "",
    eyebrow = null,
    subline = null,
    dataTestId = "logo-mark",
}) {
    const dims = SIZES[size] || SIZES.md;
    return (
        <div className={`inline-flex items-center gap-3 ${className}`} data-testid={dataTestId}>
            <div className={`flex items-center justify-center rounded-md bg-white ${dims.box}`}>
                <img
                    src={logoMark}
                    alt="The Context Project"
                    className={`w-auto select-none ${dims.img}`}
                    draggable={false}
                />
            </div>
            {(eyebrow || subline) ? (
                <div className="flex flex-col leading-tight">
                    {eyebrow ? (
                        <span className="text-[10px] uppercase tracking-[0.25em] text-[#56CCF2] font-medium">
                            {eyebrow}
                        </span>
                    ) : null}
                    {subline ? (
                        <span className="text-[11px] text-[#94A3B8]">{subline}</span>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
}
